import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { HiSparkles } from 'react-icons/hi2';
import type { SearchResultDto } from '@/types';
import {
  Card,
  CardHeader,
  Title,
  Score,
  Meta,
  Snippets,
  Snippet,
  SnippetPage,
  AiBadge,
} from './SearchResultCard.styled';

interface SearchResultCardProps {
  result: SearchResultDto;
  isCitedByAi?: boolean;
  isHighlighted?: boolean;
  id?: string;
}

export default function SearchResultCard({ result, isCitedByAi, isHighlighted, id }: SearchResultCardProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Card id={id} $cited={isCitedByAi} $highlighted={isHighlighted} onClick={() => navigate(`/documents/${result.documentId}`)}>
      <CardHeader>
        <Title>{result.fileName}</Title>
        {isCitedByAi && (
          <AiBadge>
            <HiSparkles size="0.75rem" />
            {t('search.citedByAi')}
          </AiBadge>
        )}
        <Score>
          {t('search.matchPercent', { percent: (result.score * 100).toFixed(0) })}
        </Score>
      </CardHeader>
      <Meta>
        <span>{result.documentType}</span>
        <span>{t('common.matchingSections', { count: result.snippets.length })}</span>
      </Meta>
      <Snippets>
        {result.snippets.slice(0, 5).map((snippet) => (
          <Snippet key={`${result.documentId}-${snippet.chunkIndex}`}>
            {snippet.pageNumber != null && (
              <SnippetPage>{t('search.page', { number: snippet.pageNumber })}</SnippetPage>
            )}
            <div
              dangerouslySetInnerHTML={{
                __html: snippet.highlights.length
                  ? snippet.highlights.join(' ... ')
                  : snippet.content,
              }}
            />
          </Snippet>
        ))}
      </Snippets>
    </Card>
  );
}
